'use client';

import Image from 'next/image';
import type { CollectionViewProps } from '@routeroyal/theme-core';
import { RouteRoyalProductGrid } from './ProductGrid';

export function RouteRoyalCollectionView({
  collection,
  products,
  locale = 'en',
  onAddToCart,
  className = '',
}: CollectionViewProps) {
  return (
    <div className={className}>
      {/* Collection Header */}
      <div className="relative mb-10">
        {collection.imageUrl ? (
          <div className="relative h-48 md:h-64 rounded-2xl overflow-hidden">
            <Image
              src={collection.imageUrl}
              alt={collection.title}
              fill
              className="object-cover"
              sizes="100vw"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <h1 className="text-2xl md:text-4xl font-bold text-white">
                {collection.title}
              </h1>
              {collection.description && (
                <p className="mt-2 text-white/80 max-w-2xl">
                  {collection.description}
                </p>
              )}
              <p className="mt-1 text-sm text-white/60">
                {collection.productCount} products
              </p>
            </div>
          </div>
        ) : (
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              {collection.title}
            </h1>
            {collection.description && (
              <p className="mt-3 text-gray-600 text-lg max-w-2xl">
                {collection.description}
              </p>
            )}
            <p className="mt-1 text-sm text-gray-500">
              {collection.productCount} products
            </p>
          </div>
        )}
      </div>

      {/* Products Grid */}
      <RouteRoyalProductGrid
        products={products}
        locale={locale}
        {...(onAddToCart ? { onAddToCart } : {})}
        emptyMessage="No products in this collection yet."
      />
    </div>
  );
}
